import React, { useContext, useMemo } from 'react';

import useTaskList from '../../../utils/hooks/use_task_list';

const TaskListDataContext = React.createContext({
  error: null,
  loading: false,
  taskListData: [],
  refetch: () => {},
});

export const TaskListDataContextProvider = ({ orchId, orchSha, children }) => {
  const { taskListData, loading, error, refetch } = useTaskList({ orchId, orchSha });

  const dataContextValue = useMemo(() => ({
    taskListData,
    loading,
    error,
    refetch,
  }), [
    taskListData,
    loading,
    error,
    refetch,
  ])

  return (
    <TaskListDataContext.Provider
      value={dataContextValue}
    >
      { children }
    </TaskListDataContext.Provider>
  )
};

export const useTaskListData = () => useContext(TaskListDataContext)

export default useTaskListData;
